module.exports = __webpack_public_path__ + "static/media/upgrade_risk_icon.8e86882f.svg";